import { useCallback } from 'react'

import { useModal } from '@salsita-ai/platform-project-sdk/react'

import { configuratorInterface } from '../systems/configurator-interface.js'
import { FinalizePage } from './FinalizePage.js'

export default configuratorInterface.createPhoenixHandler('getDetailsByEmail', () => {
  const { showModal } = useModal({ disableAutoDestroy: true })

  return {
    handler: useCallback(async () => {
      const modal = showModal(
        FinalizePage,
        {
          onBack: () => {
            modal.hide()
          },
        },
        {}
      )
    }, [showModal]),
  }
})
